import { CheckoutInputSchema, type CheckoutResponse, CheckoutResponseSchema } from '@cult/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../../../lib/api-client';
import { pointsKeys } from '../../points';
import { useCart } from '../cart-store';
import { marketKeys } from '../market-keys';

export const useCheckout = () => {
  const queryClient = useQueryClient();
  const clear = useCart((s) => s.clear);

  return useMutation<CheckoutResponse, Error, void>({
    mutationFn: async () => {
      const items = useCart.getState().items.map((i) => ({ skuId: i.skuId, count: i.count }));
      const body = CheckoutInputSchema.parse({ items });
      const raw = await apiFetch<unknown>('/market/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      return CheckoutResponseSchema.parse(raw);
    },
    onSuccess: () => {
      clear();
      queryClient.invalidateQueries({ queryKey: pointsKeys.me() });
      queryClient.invalidateQueries({ queryKey: marketKeys.all, exact: false });
    },
  });
};
